"use client"
import { sendBlockEvent } from "@/utils/gtm"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { colors, mediaQueries, sizes } from "ui"
import { getUmbracoMediaUrl, Item } from "utils"
import { ActionDBEntity } from "../models"
import ActionItem from "./ActionItem"

const StyledContainerItems = styled(Box)`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: ${sizes.baseTriple};
  ${mediaQueries.mobile} {
    gap: ${sizes.baseTriple};
  }
  ${mediaQueries.tablet} {
    gap: ${sizes.baseTriple};
  }
  ${mediaQueries.desktopM} {
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
  }
  ${mediaQueries.desktop} {
    padding: 0px 20px;
    margin-bottom: 64px;
  }
  ${mediaQueries.desktopXl} {
    padding: 0;
  }
`
const StyledItemBoxContainer = styled(Box)`
  background-color: ${colors.white};
  border-radius: ${sizes.baseDouble};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  ${mediaQueries.mobile} {
    padding: 40px ${sizes.baseTriple};
  }

  ${mediaQueries.tablet} {
    padding: 40px ${sizes.baseTriple};
  }

  ${mediaQueries.desktopXl} {
    padding: ${sizes.baseTriple};
    width: 500px;
    flex-shrink: 0;
  }
`
const StyledActionItemsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 12px;
  height: auto;
  ${mediaQueries.mobile} {
    gap: ${sizes.baseTriple};
  }

  ${mediaQueries.tablet} {
    gap: ${sizes.baseTriple};
  }

  ${mediaQueries.desktopXl} {
    gap: ${sizes.baseDouble};
    flex-flow: row wrap;
    height: fit-content;
    width: 100%;
  }
`
const StyledTitle = styled(Typography)<{ component?: string }>`
  ${mediaQueries.tabletDown} {
    font-size: 22px;
    line-height: 26.4px;
  }
`
interface ActionItemListProps {
  actionsItems: Record<string, Item<ActionDBEntity>[]>
  id?: string
  formDefaultInsuranceType?: string
}
const ActionItemList = ({
  actionsItems,
  id,
  formDefaultInsuranceType,
}: ActionItemListProps) => {
  const t = useTranslations("InfoFormsList")
  return (
    <StyledContainerItems>
      {Object.keys(actionsItems)?.map((key: string, index: number) => {
        const item = (actionsItems as any)[key]
        const { text, icon, itemsList } = item
        const handleItemClick = (buttonText: string) => {
          sendBlockEvent({
            blockId: id || "3", // Pass block id if available
            title: key,
            componentName: "פעולות ושרותים",
            buttonName: buttonText,
            actionName: undefined,
            productName: formDefaultInsuranceType || undefined, // Default insurance type if available

            // component_no: "5"
          })
        }

        return (
          <StyledItemBoxContainer
            key={`StyledItemBoxContainer-ActionITems${index}`}
          >
            {icon?.mediaItems && (
              <Image
                src={getUmbracoMediaUrl(
                  icon?.mediaItems && icon?.mediaItems[0]?.url,
                )}
                alt={`${t("iconAlt")}${text?.value}`}
                width={52}
                height={52}
              />
            )}
            <StyledTitle variant="h4" component="h3" color={colors.black}>
              {text?.value}
            </StyledTitle>
            <StyledActionItemsContainer>
              {itemsList?.map((item: any, index: number) => {
                const { name, link, title, itemName } = item
                return (
                  <ActionItem
                    item={{
                      ...item,
                      link: link,
                      title: name || title || itemName || "",
                    }}
                    key={`StyledItemBoxContainer-ActionItem${index}`}
                    onClick={handleItemClick}
                  />
                )
              })}
            </StyledActionItemsContainer>
          </StyledItemBoxContainer>
        )
      })}
    </StyledContainerItems>
  )
}

export default ActionItemList
